import { createContext } from "react";
export var ControlsContext = createContext({
    selected: "",
    name: "",
    register: {},
});
ControlsContext.displayName = "ControlsContext";
